import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShortLinkComponent } from './pages/short-link/short-link.component';
import { CheckCIDGuard } from './_shared/guards';

// Blad nawigacji (np. pad lazy-load w SSR) konczy sie cichym pustym
// router-outletem ze statusem 200 - bez loga niewykrywalny (incydent
// countup.js/ESM + "Runtime compiler is not loaded" 2026-07). Log + rethrow
// zachowuje domyslna semantyke bledu.
export function routerErrorLogger(error: Error): never {
  console.error(
    '[Router] NavigationError:',
    error && error.message ? error.message : error
  );
  throw error;
}

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/prad'
  },
  {
    path: 'e/:base64',
    canActivate: [CheckCIDGuard],
    component: ShortLinkComponent,
    data: {
      title: 'przekierowanie ...'
    }
  },
  // {
  //   path: 'program-partnerski',
  //   canActivate: [CheckCIDGuard],
  //   data: {
  //     title: 'Program partnerski',
  //     description: 'Zarabiaj na poleceniach porównywarki energii. Dołącz do naszego programu partnerskiego.'
  //   },
  //   loadChildren: () =>
  //     import('./pages/af-program/af-program.module').then(m => m.AfProgramModule)
  // },
  // {
  //   path: 'newsletter',
  //   canActivate: [CheckCIDGuard],
  //   data: {
  //     title: 'Newsletter',
  //     description: 'Zapisz się newsletter informacyjny o istotnych zmianach w energetyce. Prowadzisz firmie, szkole, wspólnotę, stowarzyszenie, gospodarstwo rolnym czy JST? Dostęp do świeżych informacji maksymalnie raz w tygodniu'
  //   },
  //   loadChildren: () =>
  //     import('./pages/newsletter/newsletter.module').then(
  //       m => m.NewsletterModule
  //     )
  // },
  // {
  //   path: 'kontakt',
  //   canActivate: [CheckCIDGuard],
  //   data: {
  //     title: 'Kontakt',
  //     description: '📞502 222 922 - Uzyskaj przewagę nad konkurencją. Nasi doradcy udzielają wsparcie w kwestiach energii w Twojej firmie, szkole, wspólnotcie, stowarzyszeniu, gospodarstwie rolnym czy JST.'
  //   },
  //   loadChildren: () =>
  //     import('./pages/contact/contact.module').then(m => m.ContactModule)
  // },
  // Title/description PER BRANZA (nie statyczny "Wirtualny broker energii" dla
  // wszystkich 3) - inaczej Google deduplikuje huby: identyczny <title>/<meta
  // description> => "Duplicate, Google chose different canonical" (fotowoltaika
  // zwijana do gazu mimo poprawnego self-canonical). MetadataService dokleja
  // sufix " | ZatrzymajLicznik.pl" gdy title < 70 znakow.
  {
    path: 'gaz',
    canActivate: [CheckCIDGuard],
    data: {
      title: 'Porównaj ceny gazu dla firm',
      description:
        'Ten sam gaz, ta sama rura - niższa cena. Porównaj oferty sprzedawców ' +
        'gazu dla firm i przestań przepłacać. Szybko i bez zobowiązań.'
    },
    loadChildren: () =>
      import('./pages/product/product.module').then(m => m.ProductModule)
  },
  {
    path: 'prad',
    canActivate: [CheckCIDGuard],
    data: {
      title: 'Porównaj ceny prądu dla firm',
      description:
        'Sprawdź w 2 minuty, gdzie Twoja firma zapłaci najmniej za prąd. ' +
        'Realne oferty sprzedawców, oszczędności do 30% rocznie. Bez zobowiązań.'
    },
    loadChildren: () =>
      import('./pages/product/product.module').then(m => m.ProductModule)
  },
  {
    path: 'fotowoltaika',
    canActivate: [CheckCIDGuard],
    data: {
      title: 'Dobierz fotowoltaikę dla firmy',
      description:
        'Porównaj oferty sprawdzonych instalatorów PV, poznaj realny czas ' +
        'zwrotu i uniezależnij firmę od podwyżek cen prądu.'
    },
    loadChildren: () =>
      import('./pages/product/product.module').then(m => m.ProductModule)
  },
  { path: '**', redirectTo: '/prad' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { errorHandler: routerErrorLogger })],
  exports: [RouterModule],
  providers: [CheckCIDGuard]
})
export class AppRoutingModule {}
